import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    palette: {
        primary: {
            main: '#79bde8'
        },
        secondary: {
            main: '#4E2382'
        },
        white: {
            main: '#FFFFFF'
        },
        black: {
            main: '#000000'
        },
        text: {
            primary: '#000000',
            secondary: '#FFFFFF',
            tertiary: '#818181'
        },
    },
});
